import axiosWithToken from "axiosWithToken";
import {
  campaignNotifiedToPayload,
  PlatformSettingsPayload,
  SetPlatformSettingsPayload,
} from "./types";

const headerName = process.env
  .REACT_APP_VERIFIED_LISTING_WEBHOOK_USERNAME as string;
const headerValue = process.env
  .REACT_APP_VERIFIED_LISTING_WEBHOOK_SECRET as string;
const GET_PLATFORM_SETTINGS_URL = process.env
  .REACT_APP_GET_PLATFORM_SETTINGS_URL as string;

const SET_PLATFORM_SETTINGS_URL = process.env
  .REACT_APP_SET_PLATFORM_SETTINGS_URL as string;

const baseURL2 = process.env.REACT_APP_BASEURL2;

export const getPlatformSettings = async (
  userId: string
): Promise<PlatformSettingsPayload> => {
  try {
    const response = await axiosWithToken.get<PlatformSettingsPayload>(
      GET_PLATFORM_SETTINGS_URL,
      {
        headers: {
          [headerName]: headerValue,
        },
        params: {
          userID: userId,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching platform settings:", error);
    throw error;
  }
};

export const setPlatformSettings = async (
  payload: SetPlatformSettingsPayload
): Promise<PlatformSettingsPayload> => {
  try {
    const response = await axiosWithToken.post<PlatformSettingsPayload>(
      SET_PLATFORM_SETTINGS_URL,
      payload,
      {
        headers: {
          [headerName]: headerValue,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error saving platform settings:", error);
    throw error;
  }
};

export const setCampaignNotifiedToEmail = async (
  payload: campaignNotifiedToPayload
) => {
  try {
    const response = await axiosWithToken.patch(
      `${baseURL2}api/user/update/notify-to`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error;
  }
};
